import { ClassesMapper, useClasses } from '@xo-union/react-css-modules';
import React, { useMemo } from 'react';
import { match } from 'react-router-dom';

import styles from './previewOverlay.scss';

interface Props {
  onClick?: () => void;
  classes?: ClassesMapper<string>;
  match: match<{}> | null;
  messageType: 'email' | 'SMS';
}

const PreviewOverlay: React.FC<Props> = ({ messageType, classes: classesProp, onClick, match, children }) => {
  // @ts-ignore
  const classes = useClasses(styles, classesProp);

  const display = useMemo(() => {
    return <div className={classes.editLabel}>Compose {messageType}</div>;
  }, [classes, messageType]);

  return (
    <div className={classes.previewContainer}>
      <div className={classes.previewFrame}>
        <div className={classes.previewScrollableFrame}>
          <div
            data-testid="edit-message-overlay"
            className={`${classes.previewOverlay} ${!match ? classes.visible : ''}`}
            onClick={onClick}
          >
            {display}
          </div>
          <div className={classes.bodyContainer}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default PreviewOverlay;
